export default __webpack_public_path__ + "static/media/restaumatic.97d204ee.svg";